export const  convertDateFormat = (inputDate) => {
  // Create a new Date object from the input string
  const date = new Date(inputDate);

  // Define options for formatting the date
  const options = { year: 'numeric', month: 'long', day: 'numeric' };

  // Use toLocaleString to format the date according to the options
  return date.toLocaleString('fr-FR', options);
}
